/**
 * Shared OAuth constants between frontend and backend.
 * These must stay in sync with backend API route implementations.
 */

/**
 * OAuth error codes used in redirect URLs.
 * These are set by backend routes and read by frontend hooks.
 */
export const OAUTH_ERROR_CODES = {
  YOUTUBE_NO_CHANNEL: "youtube_no_channel",
  // Add other error codes as needed
} as const;

/**
 * OAuth error parameter keys that appear in redirect URLs.
 * Using a keyed object prevents brittle array-index access patterns.
 */
export const OAUTH_ERROR_PARAM_KEYS = {
  ERROR: "error",
  ERROR_MESSAGE: "error_message",
  ERROR_CODE: "error_code",
  ERROR_HINT: "error_hint",
  ERROR_DETAILS: "error_details",
  DETAILS: "details",
  DETAILS_ERROR: "details_error",
} as const;

/**
 * OAuth error parameter names as an array.
 * Automatically derived from OAUTH_ERROR_PARAM_KEYS to ensure all parameters are included for cleanup.
 */
export const OAUTH_ERROR_PARAMS = Object.values(OAUTH_ERROR_PARAM_KEYS);

export type OAuthErrorCode = typeof OAUTH_ERROR_CODES[keyof typeof OAUTH_ERROR_CODES];
export type OAuthErrorParam = typeof OAUTH_ERROR_PARAM_KEYS[keyof typeof OAUTH_ERROR_PARAM_KEYS];
